import { render } from "./logo_logotyp.vue?vue&type=template&id=2e9fa01d&scoped=true"
import script from "./logo_logotyp.vue?vue&type=script&lang=js"
export * from "./logo_logotyp.vue?vue&type=script&lang=js"

import "./logo_logotyp.vue?vue&type=style&index=0&id=2e9fa01d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9fa01d"]])

export default __exports__